import React from "react";
import Carousel from "react-material-ui-carousel";
import LearnLanguage from "./LearnLanguage";
import { Container } from "@material-ui/core";
import slidesInfo from "./learnLanguagesData.js";
import "./learn.css";

const Slide = () => {
  return (
    <Container className="homeCarousel">
      <Carousel>
        {slidesInfo.map((slide) => {
          return <LearnLanguage key={slide.id} src={slide.src} />;
        })}
      </Carousel>
    </Container>
  );
};

export default Slide;
